import {Flex, Input, Text, Title} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react-lite';
import React, {useMemo} from 'react';
import classNames from 'classnames';
import {reportGeneratorsStore} from '../stores/ReportGeneratorsStore';
import texts from '../texts';
import FormsSelect from './FormsSelect';
import {CheckBoxItem} from './CheckBoxItem';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../utils/dataTestId';
import {isRTL} from '../../../Localization';

const ReportData = observer(() => {
    const {currentScreen} = reportGeneratorsStore;
    const {currentReport, forms} = currentScreen;
    const {
        isGeneral,
        isActive,
        title,
        nodeId,
        columns,
        isNew,
        setNodeId,
        toggleIsGeneral,
        setReportTitle,
        toggleIsActive,
        isUseAsDataset,
        toggleUseAsDataset,
        toggleIsTabular,
        isTabular
    } = currentReport;

    const formTitle = useMemo(() => forms.get(nodeId)?.Title, [nodeId]);

    return (
        <Flex justifyContent="flex-start" componentClasses={styles.reportDataContainer}>
            <Flex componentClasses={styles.basicDataContainer}>
                <div className={styles.basicDataInput}>
                    <Text skin="label-1" componentClasses={styles.reportDataLabel} wrap={false}>
                        {texts.baseFormLabel}
                    </Text>
                    <div
                        {...createDataTestId('new-report-baseform-input')}
                        className={styles.reportDataInputContainer}
                    >
                        {isNew && !columns?.length ? (
                            <FormsSelect
                                value={nodeId}
                                onSelect={setNodeId}
                                direction={isRTL() ? 'rtl' : 'ltr'}
                            />
                        ) : (
                            <Input
                                componentClasses={classNames(
                                    styles.reportDataInput,
                                    styles.disabledInput
                                )}
                                disabled
                                size="large"
                                value={formTitle}
                            />
                        )}
                    </div>
                </div>
                <div className={styles.basicDataInput}>
                    <Flex justifyContent="flex-start" componentClasses={styles.requiredlabel}>
                        <Text skin="label-1" wrap={false}>
                            {texts.reportName}
                        </Text>
                        <Text
                            tag="span"
                            textColor="validation-red"
                            componentClasses={styles.requiredMark}
                        >
                            *
                        </Text>
                    </Flex>
                    <Input
                        state={!title ? 'error' : null}
                        componentClasses={styles.reportDataInput}
                        size="large"
                        maxLength={32}
                        placeholder={texts.reportNameLabel}
                        onChange={e => setReportTitle(e.target.value)}
                        value={title}
                        autoFocus
                        {...createDataTestId('new-report-name-input', true)}
                    />
                </div>
            </Flex>
            <Flex
                justifyContent="flex-start"
                alignItems="flex-start"
                componentClasses={classNames(
                    styles.basicDataContainer,
                    styles.basicDataContainerCheckbox,
                    styles.gap
                )}
                {...createDataTestId('report-settings-checkbox-section', true)}
            >
                <Title skin="h6" textColor="primary-700">
                    {texts.advancedSettings}:
                </Title>
                <Flex
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    wrap
                    componentClasses={styles.checkBoxItemsWrapper}
                >
                    <CheckBoxItem
                        title={texts.shared}
                        onClick={toggleIsGeneral}
                        isChecked={isGeneral}
                        helpText={texts.sharedHelp}
                    />
                    <CheckBoxItem
                        title={texts.active}
                        onClick={toggleIsActive}
                        isChecked={isActive}
                        helpText={texts.activeHelp}
                    />
                    <CheckBoxItem
                        title={texts.useAsDataset}
                        onClick={toggleUseAsDataset}
                        isChecked={isUseAsDataset}
                        helpText={texts.datasetHelp}
                    />
                    <CheckBoxItem
                        title={texts.tabularCheckBox}
                        onClick={toggleIsTabular}
                        isChecked={isTabular}
                        helpText={texts.tabularHelp}
                        // handleHelp={handleCheckBoxHelp(texts.tabularHelp)}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
});

export default ReportData;
